import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
  return (
    <div className="h-screen flex flex-col overflow-hidden">
      {/* HEADER */}
      <Header />

      <div className="flex flex-1 overflow-hidden">
        {/* SIDEBAR */}
        <Sidebar />

        {/* CONTENT */}
        <div className="flex-1 overflow-y-auto bg-[#F8FAFC]">
          <div className="min-h-full flex flex-col">
            {/* PAGE CONTENT */}
            <div className="flex-1 p-4">
              <Outlet />
            </div>

            {/* FOOTER */}
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
